<script setup lang="ts">
import { SCIcon } from '@nsftx/seven-components'
import { useWalletBalanceStore } from '@/stores/wallet/walletBalanceStore'
import STWalletBalanceDetailsHeader from './STWalletBalanceDetailsHeader.vue'
import STWalletBalanceLastTransactions from './STWalletBalanceLastTransactions.vue'
import { useWalletStore } from '@/stores/wallet/walletStore'
import { computed } from 'vue'
import { formatNumber, getCurrencySymbol } from '@nsftx/seven-nxg-retail-vue-sdk'

interface MultipleWalletItemDetailsProps {
  walletId: string
}

// macros
const { walletId } = defineProps<MultipleWalletItemDetailsProps>()

// stores
const { hideWalletBalanceMultipleItemModal } = useWalletBalanceStore()
const { wallets } = useWalletStore()

// computeds
const walletItemCurrency = computed(
  () => wallets!.find((wallet) => wallet.id === walletId)!.currency
)

const walletItemBalance = computed(() => {
  const wallet = wallets!.find((wallet) => wallet.id === walletId)!
  return formatNumber(wallet.balance, {
    style: 'currency',
    currencySymbol: getCurrencySymbol(wallet.currency)
  })
})

// methods
const handleGoBackClick = () => {
  hideWalletBalanceMultipleItemModal()
}
</script>

<template>
  <div class="st-wallet-balance-details__multiple-item st-flex-column">
    <STWalletBalanceDetailsHeader>
      <template #icon-left>
        <SCIcon icon="n-i-arrow-left-e" size="2xl" class="st-pointer" @click="handleGoBackClick" />
      </template>
      <template #title>{{ walletItemCurrency }} {{ $t('common_total_balance') }}</template>
      <template #value>{{ walletItemBalance }}</template>
    </STWalletBalanceDetailsHeader>
    <STWalletBalanceLastTransactions />
  </div>
</template>
